import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutSection.css";
import aboutImg from "../Component/Cpit11.jpg";

const Counter = ({ end, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 10);

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(counter);
        start = end;
      }
      setCount(Math.floor(start));
    }, 10);

    return () => clearInterval(counter);
  }, [end, duration]);

  return <h3 className="fw-bold mb-1">{count}</h3>;
};

const AboutSection = () => {
  return (
    <div className="container py-5 about-section">
      <div className="row align-items-center">
        {/* Left Side Image */}
        <div className="col-lg-5 mb-4 mb-lg-0">
          <img src={aboutImg} alt="About" className="img-fluid rounded shadow" />
        </div>

        {/* Right Side Content */}
        <div className="col-lg-7">
          <h6 className="text-danger fw-bold mb-3 position-relative about-title">
            ABOUT US
          </h6>
          <h1 className="fw-bold mb-4">
            Career Point of <br /> Information Technology
          </h1>
          <p className="text-muted mb-4">
            CPIT established in 2017, the name of Career Point of Information Technology “CPIT of Computer Education Trust” founded by Career Point Of Information Technology CPIT Education Trust nationwide as the leading provider of education programs for individuals and professionals as well. CPIT is into the field of quality education for last 8 years in different segments such as information Technology, Skill Training, Computer hardware Networking & in the field of Accounts. As the largest and most comprehensive network, CPIT offers opportunity to choose a course that best meets a student’s Unique academic and professional needs.
          </p>

          {/* Counter Boxes */}
          <div className="row text-center">
            <div className="col-md-3 col-6 mb-3">
              <div className="counter-box bg-success text-white p-4 rounded-2">
                <Counter end={123} duration={1500} />
                <small>AVAILABLE SUBJECTS</small>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="counter-box bg-primary text-white p-4 rounded-2">
                <Counter end={1234} duration={1500} />
                <small>ONLINE COURSES</small>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="counter-box bg-danger text-white p-4 rounded-2">
                <Counter end={123} duration={1500} />
                <small>SKILLED INSTRUCTORS</small>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="counter-box bg-warning text-dark p-4 rounded-2">
                <Counter end={1234} duration={1500} />
                <small>HAPPY STUDENTS</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
